(() => import(/* webpackMode: "lazy" */ "/app/src/components/LandingIndexRoot/landing.module.css"));
(() => import(/* webpackMode: "lazy" */ "/app/src/landing/components/Button.module.css"));
import(/* webpackMode: "eager" */ "/app/src/landing/components/Demo.tsx");
import(/* webpackMode: "eager" */ "/app/src/landing/components/ScanQr.tsx");
(() => import(/* webpackMode: "lazy" */ "/app/src/landing/components/Header.module.css"));
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image.js");
import(/* webpackMode: "eager" */ "/app/public/images/landing/left-phone.png");
import(/* webpackMode: "eager" */ "/app/public/images/landing/right-phone.png");
import(/* webpackMode: "eager" */ "/app/src/landing/components/TypingAnimation.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/LocalizationSwitcher/index.tsx");
(() => import(/* webpackMode: "lazy" */ "/app/src/landing/components/Title.module.css"));
(() => import(/* webpackMode: "lazy" */ "/app/src/landing/components/Card.module.css"));
(() => import(/* webpackMode: "lazy" */ "/app/src/landing/components/Chip.module.css"));
import(/* webpackMode: "eager" */ "/app/src/landing/components/Footer.tsx");
import(/* webpackMode: "eager" */ "/app/public/images/landing/print.png");
import(/* webpackMode: "eager" */ "/app/public/images/landing/pic.png");
import(/* webpackMode: "eager" */ "/app/public/images/landing/cloud.png");
import(/* webpackMode: "eager" */ "/app/public/images/landing/alarm.png");
import(/* webpackMode: "eager" */ "/app/public/images/landing/cart.png");
import(/* webpackMode: "eager" */ "/app/public/images/landing/notes.png");
import(/* webpackMode: "eager" */ "/app/public/images/landing/home.png");
import(/* webpackMode: "eager" */ "/app/public/images/landing/shake.png");
import(/* webpackMode: "eager" */ "/app/public/images/landing/qr.png");
import(/* webpackMode: "eager" */ "/app/public/images/landing/ring.png")